// @ts-nocheck
import { expected } from '@aloft/toolkit-shared';

import { RunMatchSearchResult } from '../matching/types.js';
import { PairedSaleIDs } from '../types.js';

export function makePairsFromResult(params: RunMatchSearchResult): PairedSaleIDs[] {
  const { output, propsByListingID } = params;

  return output.pairs.map(({ p1, p2 }) => ({
    p1: expected(propsByListingID[p1]?.toolkitRecordID),
    p2: expected(propsByListingID[p2]?.toolkitRecordID),
  }));
}
